<template>
  <header class="header-bio">
    <div class="inner-header-up">

      <div class="dropdown inner-header-up-group" v-bind:class="{none:!logged}">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                aria-expanded="false">
          <img src="../../../static/img/list.svg" alt="ícone de um menu com 3 barras horizontais"/>
        </button>

        <ul class="dropdown-menu default-font-size">

          <li>
            <router-link tag="li" to="/biomanager/">
              <a class="dropdown-item">Home</a>
            </router-link>
          </li>

          <li v-if="check('USERS')">
            <router-link tag="li" to="/biomanager/users">
              <a class="dropdown-item">Usuários</a>
            </router-link>
          </li>

          <li v-if="check('AGENTSUPT')">
            <router-link tag="li" to="/biomanager/agentsupdate">
              <a class="dropdown-item">Atualização de Agentes</a>
            </router-link>
          </li>

          <!-- <li v-if="check('BIO')">
            <router-link tag="li" to="/biomanager/manage">
              <a class="dropdown-item">Consulta Biométrica</a>
            </router-link>
          </li> -->

          <li v-if="check('BIO')">
            <router-link tag="li" to="/biomanager/managepsbio">
              <a class="dropdown-item">Consulta Biométrica Griaule</a>
            </router-link>
          </li>

          <!-- <li v-if="check('BIO')">
            <router-link tag="li" to="/biomanager/consultapsbio">
              <a class="dropdown-item">Consulta Biométrica PSBIO</a>
            </router-link>
          </li> -->

          <li v-if="check('BIO')">
            <router-link tag="li" to="/biomanager/consultaspid">
              <a class="dropdown-item">Consulta Biométrica SPID</a>
            </router-link>
          </li>

          <li v-if="check('BIO')">
            <router-link tag="li" to="/biomanager/findpsbioorigin">
              <a class="dropdown-item">Consulta Origem IDN</a>
            </router-link>
          </li>

          <li v-if="check('EXCBIO')">
            <router-link tag="li" to="/biomanager/delete">
              <a class="dropdown-item">Exclusão Biométrica</a>
            </router-link>
          </li>

          <!-- <li v-if="check('EXPBIO')">
            <router-link tag="li" to="/biomanager/export">
              <a class="dropdown-item">Exportação Biométrica</a>
            </router-link>
          </li> -->

          <li v-if="check('AUDIT')">
            <router-link tag="li" to="/biomanager/subjectaudit">
              <a class="dropdown-item">Auditoria de Sujeitos</a>
            </router-link>
          </li>


          <li v-if="check('FRAUD')">
            <router-link tag="li" to="/biomanager/fraud">
              <a class="dropdown-item">Análise de Fraude</a>
            </router-link>
          </li>

          <!-- <li v-if="check('STATUS')">
            <router-link tag="li" to="/biomanager/psbioinfo">
              <a class="dropdown-item">Status PsBio</a>
            </router-link>
          </li>

          <li v-if="check('ERROS')">
            <router-link tag="li" to="/biomanager/psbioerrors">
              <a class="dropdown-item">Erros PsBio</a>
            </router-link>
          </li>

          <li v-if="check('PSBIO')">
            <router-link tag="li" to="/biomanager/psbiotransactions">
              <a class="dropdown-item">Transações e Comunicação</a>
            </router-link>
          </li> -->

        </ul>
      </div>

      <div class="inner-header-up-content">

        <img src="../../../static/img/logo_certisign_24_white.png" class="logo-certisign" alt="Logo Certisign"/>

        <div v-if="logged" class="user-info-box">
          <div class="user-info-group">
            <img :src="imagePath" class="user-frame" alt="Foto de perfil do usuário"/>
            <div class="user-info-text">
              <span>Olá,</span>
              <br/>
              <span>{{ demo.displayName }}</span>
            </div>
          </div>

          <a class="user-info-exit" v-on:click="logout">
            <img src="../../../static/img/sign-out.svg" class="logo-certisign"
                 alt="ícone que indica saída do biomanager"/>
            <div class="user-info-text">
              <span>Sair</span>
            </div>
          </a>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
import roles from '../../roles'

export default {
  name: 'Header',
  data() {
    return {
      imagePath: require('../../../static/img/icons8-usuário-48.png')
    }
  },
  props: {
    logged: Boolean
  },
  created() {
    if (this.demo.avatar) {
      this.imagePath = this.demo.avatar
    }
  },
  computed: {
    demo() {
      return {
        displayName: this.$store.state.user,
        avatar: window.localStorage.getItem('picture'),
        email: this.$store.state.email
      }
    }
  },
  methods: {
    logout() {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
        window.localStorage.setItem('picture', null)
        window.localStorage.setItem('refresh_token', null)
        window.localStorage.setItem('role', null)
        window.localStorage.setItem('count', null)
      }
      this.$router.push('/biomanager/login')
    },
    check: function (key) {
      return roles.checkrole(window.localStorage.getItem('role'), key, this.action)
    }
  }
}
</script>

<style scoped>
.default-font-size, .default-font-size > ul {
  font-size: var(--font-size-14);
}
.header-bio {
  top: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  opacity: 1;
}

.inner-header-up {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  background: #211858 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #0000001A;
}

.inner-header-up-group {
  position: absolute;
  top: 12px;
  left: 30px;
}

.inner-header-up-group > button {
  background: none;

}

.inner-header-up-group > button > img {
  height: 1rem;
  width: 1rem;
  filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(137deg) brightness(103%) contrast(101%);
}

.inner-header-up-group > button:after {
  content: none;
}

.inner-header-up-group > ul {
  z-index: 10;
}

.inner-header-up-content {
  margin: 0 141px 0 141px;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 10px 0 10px 0;
  justify-content: space-between;
}

.user-info-box {
  display: flex;
  font: var(--font-size-10) normal 600 13px/20px var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  color: var(--color-ffffff);
  text-align: left;
  align-items: center;
  gap: 3rem;
}

.user-info-group {
  display: flex;
  min-width: 111px;
  min-height: 35px;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
}

.user-frame {
  display: block;
  position: relative;
  height: 32px;
  width: auto;
  border-radius: 6px;
}

.user-info-exit {
  display: flex;
  min-width: 60px;
  min-height: 20px;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  color: var(--color-ffffff);
  text-decoration: none;
}

.user-info-exit > img {
  height: 18px;
  width: 18px;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(100deg) brightness(101%) contrast(102%);
}

.user-info-exit:hover {
  color: var(--yellow);
  //filter: invert(56%) sepia(91%) saturate(615%) hue-rotate(359deg) brightness(102%) contrast(106%);
  cursor: pointer;
}

.logo-certisign {
  width: 79px;
  height: auto;
}

.user-info-text {
  font-size: 10px;
}

/* ----- MEDIA QUERY ----- */
@media (max-width: 41em) {
  /* 656px */
  .inner-header-up-content {
    margin: 0 auto 0 auto;
    padding: 10px 6%;
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?228509ad